import React from 'react'
import { Flex, Text, CurrencySelector } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import { useLocalCurrencyManager } from 'state/user/hooks'
import localCurrencies from 'config/constants/localCurrencies'
import { DEFAULT_LOCAL_CURRENCY } from 'config/constants'

const CurrencySettings = () => {
  const { t } = useTranslation()
  const [localCurrency, setLocalCurrency] = useLocalCurrencyManager()

  return (
    <Flex flexDirection="column">
      <Flex mb="12px" alignItems="center">
        <Text fontSize="14px">
          {t('Currency')}
        </Text>
        <CurrencySelector
          currentCurrency={localCurrency}
          fallbackCurrency={DEFAULT_LOCAL_CURRENCY}
          currencies={Object.keys(localCurrencies).map(c => ({
            value: localCurrencies[c].currency,
            label: localCurrencies[c].currency,
            logo: localCurrencies[c].svg,
            suffix: localCurrencies[c].symbol
          }))}
          setCurrency={setLocalCurrency}
          color="text"
        />
      </Flex>
    </Flex>
  )
}

export default CurrencySettings
